## html
<div class="node {{ type || '' }}" style="transform: translate3d({{ x }}px, {{ y }}px, 0px)">
  <sf-template path="Blackprint/nodes/template/routes.sf"></sf-template>
  <sf-template path="Blackprint/nodes/template/header.sf"></sf-template>

  <div class="content">
    <div class="left-port">
      <sf-template path="Blackprint/nodes/template/input-port.sf"></sf-template>
    </div>

    <div class="right-port">
      <sf-template path="Blackprint/nodes/template/output-port.sf"></sf-template>
    </div>
  </div>

  <sf-template path="Blackprint/nodes/template/other.sf"></sf-template>
</div>

## js-global
Blackprint.space.component('bp-default', {
	extend: Blackprint.Interface,
	keepTemplate: true,
	template: 'Blackprint/nodes/default.sf'
}, function(self, root){
	// Property of this scope
	/* self == {
		x: 0,
		y: 0,
		input: {},
		output: {},
		property: {},
	} */
});